/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Switch component
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { SwitchClassKey, SwitchProps, withStyles } from '@material-ui/core';
import SwitchMaterial from '@material-ui/core/Switch';

import SwitchStyles from './SwitchStyles';

interface IStyles extends Partial<Record<SwitchClassKey, string>> {
    focusVisible?: string;
}

export interface ISwitchProps extends SwitchProps {
    classes: IStyles;
}

const Switch = ({ classes, ...props }: ISwitchProps) => {
    return (
        <SwitchMaterial
            disableRipple
            classes={{
                checked: classes.checked,
                disabled: classes.disabled,
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
            }}
            focusVisibleClassName={classes.focusVisible}
            {...props}
        />
    );
};

export default withStyles(() => SwitchStyles)(Switch);

